import { Component, OnInit, inject } from "@angular/core";
import { AppReleaseService } from "@app/shared/services/app-release.service";
import { injectTranslation, provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";

// Navbar plugin: asks the user to reload when a deploy replaced the frontend that this tab runs.
// It does not reload by itself, because the user can have unsaved changes.
@Component({
    selector: "app-navbar-new-version",
    templateUrl: "./navbar-new-version.component.html",
    styleUrls: ["../navbar-plugin-base.scss", "./navbar-new-version.component.scss"],
    imports: [TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class NavbarNewVersionComponent implements OnInit {
    protected readonly appRelease = inject(AppReleaseService);
    private readonly translation = injectTranslation(scope);

    ngOnInit(): void {
        // Load the text now, while the chunks of this build exist. The button shows only after a
        // deploy, and the deploy can remove the chunk of this text.
        void this.translation.ready();
    }

    protected reloadPage(): void {
        window.location.reload();
    }
}
